import { Hidden } from '@mui/material'
import { GetStaticProps, NextPage } from 'next'
import { useRouter } from 'next/router'
import React, { useEffect, useState } from 'react'
import { Footer } from 'src/components/Footer/Footer'
import { Breadcrumb } from 'src/components/global/Breadcrumb'
import MainContainer from 'src/components/global/MainContainer/MainContainer'
import { PremiumModal } from 'src/components/global/PremiumModal'
import { SearchField } from 'src/components/global/SearchField'
import { Sidebar } from 'src/components/global/Sidebar'
import { ThemeOnly } from 'src/components/global/ThemeOnly'
import { ShareResources } from 'src/components/ShareResources/ShareResources'
import { UpgradeSection } from 'src/components/UpgradeSection/UpgradeSection'
import { THEME } from 'src/config/config'
import { IEnum_Content_Contenttype, useGetMyResourcesProductTypesLazyQuery } from 'src/graphql/generated/hooks'
import { useAuthDefender } from 'src/hooks/useAuthDefender'
import { useAuthenticated } from 'src/hooks/useAuthenticated'
import { useDecodedKeyword } from 'src/hooks/useGetDecodeKeyword'
import { Meta } from 'src/layout/Meta'
import { Main } from 'src/templates/Main'
import { FilterOption, FilterOptionItem, TaxonomyType } from 'src/types'

const ResourcesPage: NextPage = () => {
  useAuthDefender()
  const { isPremium } = useAuthenticated()

  const [showModal, setShowModal] = useState(false)
  const router = useRouter()

  const title = 'My Resources'
  const description = 'Enter your email address and we will send you a link to reset your password.'

  const meta = <Meta title={title} description={description} url="/my-resources/" />
  const origin = router.asPath

  const [filters, setFilters] = useState<FilterOption[]>([])

  const [loadContents, { data: topics }] = useGetMyResourcesProductTypesLazyQuery()

  useEffect(() => {
    loadContents({
      variables: {},
    })
  }, [router.isReady])

  useEffect(() => {
    // if need Topic filter, we will open it
    /* const newFilters = {
      title: TaxonomyType.Topic,
      data:
        topics?.myResourcesProductTypes.topics.map(
          (item) =>
            ({
              id: item.id.toString(),
              name: item.name,
              isPremium: item.isPremium || false,
              children: item.subTopics?.map(
                (subTopic) =>
                  ({
                    id: subTopic.id?.toString(),
                    name: subTopic.name,
                    isPremium: subTopic.isPremium || false,
                  }) as FilterOptionItem,
              ),
            }) as FilterOptionItem,
        ) || [],
    } */

    const newFilters = {
      title: TaxonomyType.Topic,
      data: [],
    }
    const contentTypes = {
      title: TaxonomyType.ContentType,
      data:
        Object.values(IEnum_Content_Contenttype)
          .map((item) => ({
            id: item as string,
            name: item.replace(/_/g, ' '),
          }))
          .filter((item): item is FilterOptionItem => !!item.id && !!item.name)
          .filter(
            (item) =>
              item.name === 'Landscape Article' ||
              item.name === 'Vendor Analysis' ||
              item.name === 'Competitive Analysis',
          ) || [],
    }

    setFilters([newFilters, contentTypes])
  }, [topics])

  const searchKeyword = useDecodedKeyword(router.query.keyword)

  return (
    <Main meta={meta}>
      <PremiumModal origin={origin} isOpen={showModal} onClose={() => setShowModal(false)} />
      <MainContainer id="mainContainer">
        <div className="flex flex-col bg-clouds">
          <Breadcrumb subject={'MY ACCOUNT'} subjectRoute={'/my-account'} subtitle={'MY RESOURCES'} />
          <div className="flex flex-row px-5 sm:px-0 justify-center">
            <div className="!max-w-[1100px] w-full flex flex-row items-center py-2 mt-[27PX] mb-[31px]">
              <span className="h-[50px] text-darkgray font-secondary font-bold text-[30px]">My Resources</span>
            </div>
          </div>
        </div>
        <hr />
        <div className="flex flex-col">
          <div className="flex justify-center">
            <div className="!max-w-[1100px] flex flex-row justify-between w-full md:mb-32">
              <Hidden mdDown>
                <div className="w-1/4 pr-10 flex flex-col">
                  <SearchField className="my-8" />
                  {filters.length > 0 && <Sidebar filterOptions={filters} defaultSelectFilterIdx={1} />}
                </div>
              </Hidden>
              <ShareResources filterProps={filters} searchKeyword={searchKeyword} />
            </div>
          </div>
        </div>

        {!isPremium && <UpgradeSection origin={origin} />}

        <ThemeOnly theme="legaltech">
          <Footer />
        </ThemeOnly>
      </MainContainer>
    </Main>
  )
}

export default ResourcesPage

export const getStaticProps: GetStaticProps = async ({}) => {
  if (THEME === 'ilta')
    return {
      revalidate: 60,
      notFound: true,
    }
  return {
    props: {},
    revalidate: 60,
  }
}
